import { useEffect, useState } from 'react'
import { NavLink, Link, Outlet, useLocation } from 'react-router-dom'
import { brand } from '../brand'

const links = [
  { to: '/clients', label: 'For clients' },
  { to: '/how-it-works', label: 'Approach' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/contact', label: 'Contact' },
]

export default function PublicLayout() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    setOpen(false)
    window.scrollTo({ top: 0 })
  }, [pathname])

  return (
    <div className="page">
      <header className="site-header frame">
        <div className="frame-inner">
          <Link to="/" className="wordmark" aria-label={`${brand.name} home`}>
            {brand.name}
          </Link>
          <button
            className="nav-toggle"
            aria-expanded={open}
            aria-controls="site-nav"
            onClick={() => setOpen((v) => !v)}
          >
            Menu
          </button>
          <nav id="site-nav" className={`nav${open ? ' open' : ''}`} aria-label="Primary">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn small">
              Speak with us
            </Link>
          </nav>
        </div>
      </header>

      <main className="frame">
        <div className="frame-inner">
          <Outlet />
        </div>
      </main>

      <footer className="site-footer frame">
        <div className="frame-inner">
          <div>
            <div className="wordmark">{brand.name}</div>
            <p className="footer-legal">
              {brand.name}
              <br />
              {brand.mailingAddress}
            </p>
          </div>
          <ul>
            <li>
              <Link to="/how-it-works">Approach</Link>
            </li>
            <li>
              <Link to="/clients">For clients</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
          <ul>
            <li>
              <Link to="/privacy">Privacy and data use</Link>
            </li>
            <li>
              <Link to="/privacy#outreach">Received our outreach?</Link>
            </li>
            <li>
              <Link to="/opt-out">Opt out of outreach</Link>
            </li>
            <li>
              <Link to="/login" className="muted">
                Analyst login
              </Link>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  )
}
